import styles from './index.module.less';
import { useState } from 'react';
import { DownOutlined } from '@ant-design/icons';
import Image from 'next/image';

const Index: React.FC<{ content: any }> = ({ content }) => {
  const showContent = content.contentInfo['section-intro'];

  const [activeIndex, setActiveIndex] = useState(0);
  if (!showContent.title) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.block}></div>
      <div className={styles.content}>
        <h2 className={styles.title}>{showContent.title}</h2>
        <div className={styles.desc}>{showContent.desc}</div>
        <ul className={styles.list}>
          {showContent.cards.map((item: any, index: number) => (
            <li key={item.title}>
              <Image
                src={item.imgPath}
                alt={item.title}
                width={150}
                height={170}
                loading="lazy"
                className={styles.img}
              />
              <div>
                <div>
                  <div>{index + 1}</div>
                  <div className={styles.mobileTitle}>{item.title}</div>
                </div>
                <div
                  className={activeIndex != index ? styles.mobileIcon : styles.mobileIconActive}
                  onClick={() => setActiveIndex(index)}
                >
                  <DownOutlined />
                </div>
              </div>
              <div className={styles.desktopTitle}>{item.title}</div>
              <div
                className={activeIndex != index ? styles.desktopDesc : styles.desktopDescActive}
                style={{
                  position: 'relative',
                  zIndex: 1,
                }}
              >
                {item.desc}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Index;
